import React, {useState,useContext,useRef,useEffect} from "react";

import { useNavigate  } from "react-router-dom";
import Lang from '../../../lang/translations';
import helpers from "../../../_helpers/helpersFunction";
import PopupGenerico from '../../../popup/popupGenerico';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import {Helmet} from "react-helmet";
import { GTMEvents } from '../../../_helpers/gtm/gtm';

import Context from '../../../context/context';

const config = require("../../../_helpers/configServizi"); 

export default function CreditCardForm(props) {

   
    const [success, setSuccess] = useState(false);
    const [orderID, setOrderID] = useState(false);
    const [payResponse, setPayResponse] = useState();
    

  let navigate = useNavigate();
  const context = useContext(Context)



    // creates a paypal order
    const createOrder = (data, actions) => {

  
        return actions.order.create({
            purchase_units: [
                {
                    description: context.rateplanScelto.nomePiano,
                    amount: {
                        currency_code: "EUR",
                        value: context.rateplanScelto.prezzo_totale,
                    },
                },
            ],
        }).then((orderID) => {
                setOrderID(orderID);
                return orderID;
            });
    };

    // check Approval
    const onApprove = (data, actions) => {
        return actions.order.capture().then(function (details) {
            helpers.logToBackend("Tentativo paypal",{pixel:true,clickid:localStorage.getItem('trackerId'),et:"tentativo"})
            helpers.kpiPanel(context,"tentativo")
           GTMEvents.add_payment_info(localStorage.getItem("trackerId"),context.email,window.location.hostname)
            setPayResponse(details)
            if(details.status == "COMPLETED"){
                
                setSuccess(true);
            }else{
                helpers.logToBackend("ARCHIVIARE ERRORE PAYPAL",details)
                errorManagement()
            }
            
        });
    };




    function errorManagement(){
            var contenuto = {
                header: Lang( {"w": "errore","page": "creditCardForm"} ),
                descrizione: Lang( {"w": "riprova","page": "creditCardForm"} )
            }

            helpers.showPopupgenerico("insufficient_funds",context,contenuto)
    } 
      
      

    useEffect(() => {
        if (success) {
            console.log('Order successful . Your order id is--', orderID);
            
            context.setPageOkEnabled(true)
            context.setPremiumLevel(context.rateplanScelto.premiumLevel)
            const credMsg = context.creditiMessaggi + context.rateplanScelto.crediti_promo
            context.setCreditiMessaggi(credMsg)
            context.setValoreMessaggio(context.flusso.valoreMessaggio)
            navigate('/ok/')

            sendResponseToBackend(payResponse)

        }
    },[success]);



    async function sendResponseToBackend(response){
console.log("SEND RESPONSE TO BACKEND",response)

        var data_request = {
            country : helpers.getCountry(),
            rateplan : context.rateplanScelto,
            descriptor : config.servizi[window.location.hostname].descriptor,
            payment_system : "paypal",
            city : localStorage.getItem("city"),
            clickid : localStorage.getItem("trackerId"),
            domain : window.location.hostname,
            email : context.email,
        }
        
        var data_response = {
            id:response.id,
            card:{
                tokenId:response.payer.payer_id
            },
            cardholderName:response.payer.name.given_name + " " + response.payer.name.surname,
            email:response.payer.email_address,
        }

        const dati = { 
            request:data_request,
            response:data_response
        }
     
      
        var token = localStorage.getItem('token');
        try{
      
          return await fetch(process.env.REACT_APP_PAY+"/orders/client/paypal/orderOk",{ 
            method: 'post', 
            headers: {
              'Accept': 'application/json, text/plain, */*',
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+ token
            },
            body: JSON.stringify(dati)
          })
          .then(res => res.json())
          .then(response => {
            return response
          })
          .catch((err)=>{
            helpers.logToBackend("Paypal Error 1",{clickid:dati.clickid,error:err.message})
          })
        }catch(err){
            helpers.logToBackend("Paypal Error try catch",{clickid:dati.clickid,error:err.message})
        }

    }



    



    return(<div className="formPagamento">
        {context.rateplanScelto && (
            
            <PayPalScriptProvider options={{ "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID, currency:"EUR","disable-funding":"card"}}>
               
                    <PayPalButtons
                        style={{ layout: "vertical", color:"white", height:50, disableMaxWidth:true}}
                        createOrder={createOrder}
                        onApprove={onApprove}
                        //fundingSource="paypal"
                        
                    />

                 
     
            </PayPalScriptProvider>
                   
        )}         
          </div>
                )

}